import BaseModal from 'components/atoms/base-modal';
import { useTranslation } from 'react-i18next';

import type { FC } from 'react';

interface Props {
  activePatientGuid: string;
  countdown: number;
  onDismiss: () => void;
}

const BlockedSessionModal: FC<Props> = ({
  activePatientGuid,
  countdown,
  onDismiss,
}) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      open
      title={t('messages.blockedSessionTitle')}
      onCancel={onDismiss}
      outsideClose={false}
      withFooter={false}
    >
      <p>
        {t('messages.blockedSessionBody', { patientGuid: activePatientGuid })}
      </p>
      <p>{t('messages.blockedSessionCountdown', { seconds: countdown })}</p>
    </BaseModal>
  );
};

export default BlockedSessionModal;
